module.exports = __webpack_public_path__ + "static/media/spinner.04a86d22.svg";